import React, { Component } from 'react'
import PropertyCard from './cards/property';
import BoughtCard from './cards/bought';
import Fade from 'react-reveal/Fade'

class TeamProperties extends Component {

  state = {
    limit: 6,
    type: this.props.current?.length > 0 ? 'current' : 'sold',
  }
  _openNewsletter = () => {
    document.querySelector('.newsletter-click').click();
  }

  render() {

    let { type, limit } = this.state
    const { sold, current, projects } = this.props
    const properties = type === 'current' ? current : type === 'projects' ? projects : sold

    return (
      <>
        <section className="team-properties">
          <div className="team-properties__inner container">
            <div className="team-properties__title">
              <h3>Obvious:</h3>
              <div className="team-properties__buttons">
                { current?.length > 0 &&
                  <button 
                    className={type === 'current' ? 'active' : ''} 
                    onClick={() => this.setState({type: 'current', limit: 6})}
                  >Listings</button>
                }
                { projects?.length > 0 &&
                  <button
                    className={type === 'projects' ? 'active' : ''}
                    onClick={() => this.setState({type: 'projects', limit: 6})}
                  >Projects</button>
                }
                { sold?.length > 0 &&
                  <button 
                    className={type === 'sold' ? 'active' : ''}
                    onClick={() => this.setState({type: 'sold', limit: 6})}
                  >Sold</button>
                }
                { process.env.GATSBY_LOCATION !== 'nz' && <button onClick={this._openNewsletter}>Subscribe</button> }
              </div>
            </div>
            <div className="team-properties__list">
              { properties?.slice(0, limit).map((el) => {
                if (type === 'projects') return (<BoughtCard key={el.node.id} {...el.node} url={'/project/'+el.node.slug} imageSource={el.node.acf.featuredImage?.localFile?.publicURL} />)
                return (<PropertyCard key={el.node.id} color={el.node.propertyData?.website_status !== 'sold'} {...el.node} />)
              })}
            </div>
            { properties?.length > limit && <button className="team-properties__load-more" onClick={() => this.setState({ limit: limit + 6})}>Load More</button> }
          </div>
        </section>
      </>
    )
  }
}

export default TeamProperties
